import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const styleProperties = {
  bgcolor: '#4b4b4b',
  placement: "bottom-start"
};

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: styleProperties.bgcolor,
    color: '#fff',
    fontSize: '0.8rem',
    fontWeight: 400,
    padding: '5px',
  },
  customArrow: {
    color: styleProperties.bgcolor,
  },
}));

const CustomTooltip = ({ placement = styleProperties.placement, arrow = false, ...props }) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{
        tooltip: classes.customTooltip,
        arrow: classes.customArrow,
      }}
      arrow={arrow}
      placement={placement}
      {...props}
    />
  );
};

export default CustomTooltip;